<template lang="pug">
  #Invitation
    appHeader(
      :targetRouterName="route"
    )
    router-view.content-body
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import { SM_ITEMS_LIST_INDEX } from '@/router/sm/items-list';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'InvitationComponent',
  components: {
    appHeader
  },
  data() {
    return {
      route: SM_ITEMS_LIST_INDEX
    };
  }
};
</script>
